
import React from 'react';
import '../Assets/Css/fabrication.css';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaIndustry, FaCogs, FaHardHat } from "react-icons/fa";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import aboutFabricationImg from '../Assets/Images/samshree_fabrication1.jpg';
import Shuttering  from '../Assets/Images/samshree_fabrication3.jpg';
import Fencing from '../Assets/Images/samshree_fabrication4.jpg';
import StreetLight from '../Assets/Images/samshree_fabrication9.jpg';
import Trusses  from '../Assets/Images/samshree_fabrication8.png';
import Roadsidesignboards from '../Assets/Images/samshree_fabrication6.png';
import Gantries from '../Assets/Images/samshree_fabrication7.jpg';

import fabricationCtaImg from '../Assets/Images/samshree_fabrication5.jpg';
import { Helmet } from 'react-helmet';

export default function FabricationErection() {
  const testimonials = [
    {
      message: "Their steel structure expertise helped us complete our industrial facility ahead of schedule.",
      author: "Project Engineer",
    },
    {
      message: "Professional team, accurate fabrication, and flawless erection. Highly recommended.",
      author: "Structural Consultant",
    },
    {
      message: "Our warehouse structure was installed with precision and safety top of mind.",
      author: "Site Manager",
    },
  ];

  const features = [
    {
      id: 1,
      icon: <FaIndustry />,
      title: "Experienced professionals and engineers",
      description: "Utilizing cutting-edge machinery and quality steel materials.",
    },
    {
      id: 2,
      icon: <FaCogs />,
      title: "Precision fabrication and safe erection practices",
      description: "Detailed drawings and fabrication accuracy within tight tolerances.",
    },
    {
      id: 3,
      icon: <FaHardHat />,
      title: "Timely project delivery",
      description: "Experienced rigging crews ensure safe on-site structure erection.",
    },
     {
      id: 4,
      icon: <FaCogs />,
      title: "Custom solutions for all infrastructure needs",
      description: "Detailed drawings and fabrication accuracy within tight tolerances.",
    },
    {
      id: 5,
      icon: <FaHardHat />,
      title: "Compliance with industry standards and safety regulations",
      description: "Experienced rigging crews ensure safe on-site structure erection.",
    },
  ];

  const services = [
  {
    title: 'Shuttering, Overhead & Cantilever Gantry, Foot Over Bridges, Toll Plaza Canopy',
    description: 'Fabrication of Shuttering, overhead & Cantilever Gantry, Foot Over Bridges and Toll Plaza Canopy etc.',
    image: Shuttering,
  },
  {
    title: 'Highway Fencing, Crash Barrier (MBCB) & Barbod Fencing',
    description: 'Fabrication & Installation of highway Fencing, Crash Barrier (MBCB) & Barbod Fencing Work.',
    image: Fencing,
  },
  {
    title: 'Decorated Street Light Poles & Solar Light Poles',
    description: 'Fabrication & Installation work of decorated street light poles, Solar Light Pole.',
    image: StreetLight,
  },
  {
    title: 'Trusses for Workshop & Godown Installation',
    description: 'Fabrication & Erection of Trusses for Workshop and Godown Installation.',
    image: Trusses,
  },
  {
    title: 'Road Side Sign Boards',
    description: 'Road Side Sign Boards Fabrication and Installation.',
    image: Roadsidesignboards,
  },
  {
    title: 'Gantries, FOBs & Composite Girder ROBs',
    description: 'Erection of all type gantries, FOB\'s & Composite Girder ROB.',
    image: Gantries,
  },
];


  return (
    <div className="mainnav min-vh-100">

      <Helmet>
        <title>Fabrication & Erection Services | Samashree Enterprises Pvt. Ltd.</title>
        <meta
          name="description"
          content="Samashree Enterprises specializes in steel fabrication and erection services including gantries, foot over bridges, toll plaza canopies, fencing, and more with over 20 years of precision engineering experience."
        />
        <meta
          name="keywords"
          content="fabrication services, erection services, gantry fabrication, foot over bridge installation, crash barriers, toll plaza canopy, steel structures India, Samashree Enterprises"
        />
        <meta name="author" content="Samashree Enterprises Pvt. Ltd." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.samashreeenterprises.com/fabrication-services" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Fabrication & Erection Services | Samashree Enterprises" />
        <meta
          property="og:description"
          content="Precision-engineered fabrication and erection services for industrial and infrastructure projects by Samashree Enterprises Pvt. Ltd."
        />
        <meta property="og:url" content="https://www.samashreeenterprises.com/fabrication-services" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.samashreeenterprises.com/images/fabrication-banner.jpg" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Fabrication & Erection Services | Samashree Enterprises" />
        <meta
          name="twitter:description"
          content="Specialists in gantry, FOB, crash barrier, and truss fabrication and erection. 20+ years of excellence."
        />
        <meta name="twitter:image" content="https://www.samashreeenterprises.com/images/fabrication-banner.jpg" />
      </Helmet>

      {/* Hero Section */}
      <section className="hero-section4">
        <div className="overlay text-center text-white d-flex flex-column justify-content-center align-items-center">
          <h1 data-aos="zoom-in" >Fabrication & Erection Services</h1>
          <p data-aos="zoom-in" data-aos-delay="100">Precision-engineered steel solutions for industrial and commercial projects.</p>
          <a href="/contact" className="btn-get mt-3" data-aos="fade-up" data-aos-delay="100">Request Quote</a>
        </div>
      </section>

      {/* About Us Section */}
      

      <section className="about-us py-5">
  <Container>
    <Row className="align-items-center">
      <Col md={5} className="d-flex justify-content-center">
        <img
          src={aboutFabricationImg}
          alt="About Fabrication"
          className="img-fluid aboutsecimg rounded shadow mb-3"
          data-aos="zoom-in" data-aos-delay="100"
        />
      </Col>
      <Col md={7}>
        <h2 className="page-title text-center mb-4" data-aos="fade-up">Overview</h2>
        <p  style={{textAlign:'justify'}} data-aos="zoom-in" data-aos-delay="100">
          At <strong>Samashree Enterprises Pvt. Ltd.</strong>, We specialize in the fabrication and installation of key infrastructure elements, including shuttering, overhead and cantilever gantries, foot over bridges, and toll plaza canopies. Our expertise extends to the installation of highway fencing, crash barriers (MBCB), and barbed fencing, ensuring enhanced road safety and durability. We also fabricate and install decorative street light poles and solar light poles, offering both aesthetic appeal and sustainable energy solutions. Additionally, we provide fabrication and erection of trusses for workshops and Godown installations, delivering robust structural solutions for industrial spaces. Our services include the precise fabrication and installation of roadside signboards for effective communication and navigation. Furthermore, we are experienced in the erection of all types of gantries, foot over bridges (FOBs), and composite girder rail over bridges (ROBs), contributing to the development of essential transportation infrastructure.
        </p>
        <ul className="ps-4" data-aos="zoom-in" data-aos-delay="100">
          <li>In-house fabrication facility</li>
          <li>Certified welders and fitters</li>
          <li>Experienced erection crews with crane operation</li>
        </ul>
      </Col>
    </Row>
  </Container>
</section>


      {/* Why Choose Us Section */}
      <section>
        <h2 className="page-title " data-aos="fade-up" >Why Choose Us</h2>
      <section className="why-choose-us-bg4 py-5 bg-light">
        <Container>
          <Row className="text-center">
            {features.map(({ id, icon, title }) => (
              <Col key={id} md={4} className="mb-4">
                <Card className="feature-card1 h-100 p-4 shadow-sm" data-aos="zoom-in" data-aos-delay="100">
                  <div className="icon-box mb-3">{icon}</div>
                    <h5 className="choosetitle fw-bold">{title}</h5>
                  
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
       </section>


      {/* Services Section */}
      <section className="services-content py-5 bg-light">
        <Container>
          <h2 className="page-title text-center mb-4" data-aos="fade-up">Our Fabrication & Erection Services</h2>
          <Row>
            {services.map((service, index) => (
              <Col md={4} sm={12} className="mb-4" key={index}>
                <Card className="h-100 border-0 hover-shadow" data-aos="zoom-in" data-aos-delay="100">
                  <Card.Img variant="top" src={service.image} alt={service.title} className="service-image" />
                  <Card.Body>
                    <Card.Title style={{ color: '#008080', textAlign: 'center' }}>{service.title}</Card.Title>
                    <Card.Text>{service.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Contact CTA Section */}
      <section className="contact-cta py-4 text-center">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="text-center text-md-start mb-3" data-aos="zoom-in">
              <h2>Need Steel Structure Experts?</h2>
              <p className="lead">We’re ready to fabricate and erect your vision. Let's get started!</p>
              <a href="/contact" className="btn-get">Contact Us</a>
            </Col>
            <Col md={6}>
              <div className="d-flex justify-content-center">
                <img
                  src={fabricationCtaImg}
                  alt="Steel Structure Team"
                  className="img-fluid rounded shadow"
                  data-aos="zoom-in" data-aos-delay="100"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials py-5 bg-light">
        <Container>
          <h2 className="page-title text-center" data-aos="fade-up">Client Testimonials</h2>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 5000 }}
                loop={true}
                pagination={{ clickable: true }}
              >
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <Card className="p-4 mb-4 border-0 text-center" data-aos="zoom-in" data-aos-delay="100">
                      <p >⭐️⭐️⭐️⭐️⭐️</p>
                      <p className="mb-3" style={{ fontStyle: 'italic' }}>“{testimonial.message}”</p>
                      <small className="text-muted">— {testimonial.author}</small>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}
